/* TR -- open header submenus on hover.
   Horizon's submenus are <details> elements that open on click. We mirror
   that state on pointer enter/leave with a short close delay, so the
   pointer can cross the gap to the panel. Click and keyboard still work,
   because we only toggle the same `open` attribute Horizon already uses. */
(function () {
  function init() {
    var menu = document.querySelector('.header-menu');
    if (!menu) return;
    if (!window.matchMedia('(hover: hover)').matches) return;
    if (window.matchMedia('(max-width: 749px)').matches) return;

    var items = menu.querySelectorAll('.menu-list__list-item');

    items.forEach(function (item) {
      var details = item.querySelector('details');
      if (!details) return;

      var closeTimer = null;

      function setExpanded(state) {
        var trigger = details.querySelector('summary, .menu-list__link');
        if (trigger) trigger.setAttribute('aria-expanded', state ? 'true' : 'false');
      }

      function open() {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        items.forEach(function (other) {
          if (other === item) return;
          var d = other.querySelector('details');
          if (d && d.open) d.open = false;
        });
        details.open = true;
        setExpanded(true);
      }

      function close() {
        closeTimer = setTimeout(function () {
          details.open = false;
          setExpanded(false);
        }, 180);
      }

      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      items.forEach(function (item) {
        var d = item.querySelector('details');
        if (d) d.open = false;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();